import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="preserve-scroll"
export default class extends Controller {
  connect() {
    window.preserveScroll ||= {};

    this.element.addEventListener("scroll", this.onElementScroll.bind(this));

    this.restoreScroll();
  }

  disconnect() {
    super.disconnect();

    this.element.removeEventListener("scroll", this.onElementScroll);
  }

  getIdentifier() {
    return this.element.dataset.scrollIdentifier || this.element.id
  }

  onElementScroll() {
    window.preserveScroll[this.getIdentifier()] = this.element.scrollTop;
  }

  restoreScroll() {
    const shouldScrollToPosition = this.element.dataset.preserveScrollEnabledValue == null || this.element.dataset.preserveScrollEnabledValue === 'true'
    if (shouldScrollToPosition) {
      const identifier = this.getIdentifier();
      if (window.preserveScroll[identifier]) {
        this.element.scrollTo(0, window.preserveScroll[identifier]);
      }
    }
  }
}
